<div class="main-content" *ngIf="resource$ | async as resource">
  <div class="tw-flex tw-justify-between tw-items-center">
    <div>
      <h2 class="tw-text-3xl tw-font-dm-sans tw-font-bold tw-my-2">
        {{ resource.resource_name }}
      </h2>
      <h3 class="tw-text-lg tw-font-dm-sans tw-font-bold">
        {{ resource.resource_long_name }}
      </h3>
    </div>
    <!-- Action Buttons -->
    <div class="tw-flex tw-items-center tw-gap-2">
      <!-- API Access Button -->
      <a
        routerLink="/api/"
        class="tw-font-bold tw-px-4 tw-p-2 tw-border-2 tw-border-gray-800 hover:tw-border-apicuron-purple-500 focus:tw-ring-1 focus:tw-border-apicuron-purple-500 tw-rounded-md tw-bg-white hover:tw-bg-purple-50 tw-text-gray-800 hover:tw-text-apicuron-purple-500 tw-flex tw-items-center tw-transition-colors"
        title="Access API Documentation"
      >
        <img
          src="assets/svg/api.svg"
          width="18px"
          height="auto"
          alt="API Icon"
          class="tw-mr-2"
        />
        <span>API Docs</span>
      </a>

      <!-- Visit Website Button -->
      <a
        [href]="resource.resource_url"
        target="_blank"
        class="tw-font-bold tw-px-4 tw-p-2 tw-border-2 tw-border-black hover:tw-border-2 hover:tw-border-apicuron-purple-500 focus:tw-ring-1 focus:tw-border-2 focus:tw-border-apicuron-purple-500 tw-rounded-md tw-bg-purple-100 tw-text-apicuron-purple-500 tw-flex tw-items-center"
      >
        <span class="tw-mr-2">Visit website</span>
        <img
          src="assets/svg/world-wide-web-svgrepo-com.svg"
          width="18px"
          height="auto"
          alt="Name Icon"
        />
      </a>
    </div>
  </div>

  <div
    class="tw-flex tw-flex-row md:tw-flex-row-reverse tw-items-start tw-my-2 tw-flex-wrap md:tw-flex-nowrap"
    *ngIf="terms$ | async as terms"
  >
    <div class="tw-w-full tw-flex tw-flex-col" #mainPanel>
      <p
        class="tw-leading-relaxed tw-tracking-wide tw-pr-2 tw-mb-2 tw-text-justify"
      >
        {{ resource.resource_description }}
      </p>
      <div *ngIf="resource.stats">
        <div class="tw-flex tw-justify-between tw-items-center tw-mb-1">
          <span class="tw-font-bold">Database statistics</span>
          <a
            routerLink="/api"
            class="tw-text-xs tw-font-bold tw-text-apicuron-purple-500 hover:tw-text-apicuron-purple-600 hover:tw-underline tw-flex tw-items-center tw-gap-1.5"
          >
            <img
              src="assets/svg/api.svg"
              class="tw-w-4 tw-h-4"
              alt="API Icon"
            />
            <span>Data available via API</span>
          </a>
        </div>
        <div
          class="tw-flex tw-py-2 tw-mb-2 tw-gap-1 tw-flex-row md:tw-flex-nowrap tw-items-stretch tw-flex-wrap"
        >
          <ng-container *ngFor="let card of statCards">
            <div
              *ngIf="card.show"
              class="md:tw-w-1/4 tw-w-1/2 tw-flex tw-flex-col"
            >
              <number-card
                [label]="card.label"
                [value]="
                  card.valueKey.includes('Date')
                    ? (resource?.stats?.[card.valueKey] | date: 'dd/MM/yyyy')
                    : resource?.stats?.[card.valueKey]
                "
                [iconSrc]="card.iconSrc"
                [description]="card.description"
              ></number-card>
            </div>
          </ng-container>
        </div>

        <!-- Resource Contributors Credit Section & Login CTA -->
        <div class="tw-my-4 tw-flex tw-flex-col tw-gap-3">
          <!-- Resource Contributors Credit Card -->
          <div
            class="tw-bg-white tw-rounded-lg tw-border tw-border-gray-200 tw-p-4 tw-shadow-sm tw-flex tw-flex-col tw-gap-4"
          >
            <div
              class="tw-flex tw-flex-col sm:tw-flex-row tw-items-start sm:tw-items-center tw-justify-between tw-gap-4"
            >
              <div class="tw-flex tw-items-center tw-gap-3">
                <div
                  class="tw-p-2.5 tw-bg-purple-50 tw-rounded-lg tw-text-apicuron-purple-500"
                >
                  <img
                    src="assets/svg/member.svg"
                    class="tw-w-6 tw-h-6"
                    alt="Contributors"
                  />
                </div>
                <div>
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <h4 class="tw-font-bold tw-text-gray-900 tw-text-base">
                      Resource Contributors
                    </h4>
                    <span
                      class="tw-bg-purple-100 tw-text-apicuron-purple-700 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-0.5 tw-rounded-full"
                    >
                      {{ resource.stats?.uniqueContributors || 0 }} total
                    </span>
                  </div>
                  <p class="tw-text-xs tw-text-gray-600 tw-mt-0.5">
                    Contributors whose work and events are tracked and credited
                    for {{ resource.resource_name }}.
                  </p>
                </div>
              </div>

              <!-- View All Contributors Link -->
              <a
                [routerLink]="['/contributors']"
                [queryParams]="{ resources: resource.resource_id }"
                class="tw-shrink-0 tw-px-4 tw-py-2 tw-text-sm tw-font-bold tw-text-apicuron-purple-500 tw-bg-purple-50 hover:tw-bg-purple-100 tw-rounded-md tw-transition-colors tw-flex tw-items-center tw-gap-1.5 tw-border tw-border-purple-200"
              >
                <span>View all contributors</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="tw-h-4 tw-w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>

            <!-- Top Contributors Preview List -->
            <div *ngIf="topContributors$ | async as topContributors">
              <div
                *ngIf="topContributors.length > 0; else noContributors"
                class="tw-flex tw-flex-wrap tw-gap-2.5 tw-pt-3 tw-border-t tw-border-gray-100"
              >
                <a
                  *ngFor="let item of topContributors"
                  [routerLink]="['/contributors', item.user.orcid_id]"
                  class="tw-flex tw-items-center tw-gap-2.5 tw-px-3 tw-py-1.5 tw-bg-gray-50 hover:tw-bg-purple-50 tw-border tw-border-gray-200 hover:tw-border-purple-300 tw-rounded-full tw-transition-all group"
                  [title]="
                    item.user.displayedName + ' (' + item.user.orcid_id + ')'
                  "
                >
                  <img
                    [src]="item.user.avatar"
                    class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-white tw-border tw-border-gray-200 tw-object-cover"
                    alt="{{ item.user.displayedName }}"
                  />
                  <span
                    class="tw-text-xs tw-font-semibold tw-text-gray-800 group-hover:tw-text-apicuron-purple-600"
                  >
                    {{ item.user.displayedName }}
                  </span>
                  <span
                    *ngIf="item.events_count"
                    class="tw-text-[10px] tw-font-bold tw-text-gray-500 tw-bg-gray-200/70 group-hover:tw-bg-purple-100 group-hover:tw-text-purple-700 tw-px-2 tw-py-0.5 tw-rounded-full"
                  >
                    {{ item.events_count }} contributions
                  </span>
                </a>
              </div>
              <ng-template #noContributors>
                <div class="tw-pt-2 tw-border-t tw-border-gray-100">
                  <p class="tw-text-xs tw-text-gray-500 tw-italic">
                    No recorded contributors yet for this resource.
                  </p>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Credit & Recognition Call-To-Action Banner (for non-logged in users) -->
          <div
            *ngIf="isLoggedOut$ | async"
            class="tw-bg-gradient-to-r tw-from-purple-50 tw-via-indigo-50/50 tw-to-purple-50/30 tw-rounded-lg tw-p-5 tw-shadow-sm tw-flex tw-flex-col sm:tw-flex-row tw-items-start sm:tw-items-center tw-justify-between tw-gap-4 tw-border tw-border-purple-200/70"
          >
            <div class="tw-space-y-1">
              <div class="tw-flex tw-items-center tw-gap-2">
                <span
                  class="tw-bg-purple-100 tw-text-apicuron-purple-700 tw-text-[11px] tw-font-bold tw-px-2.5 tw-py-0.5 tw-rounded-full"
                >
                  Contributor Recognition
                </span>
              </div>
              <h3 class="tw-text-base tw-font-bold tw-font-dm-sans tw-text-gray-900">
                Do you contribute to {{ resource.resource_name }}?
              </h3>
              <p
                class="tw-text-xs tw-text-gray-600 tw-max-w-2xl tw-leading-relaxed"
              >
                Connect your ORCID iD to claim credit for your work, track your
                contributions over time, and ensure your contributions are
                formally recognized.
              </p>
            </div>

            <button
              (click)="authService.openOauthDialog('database')"
              class="tw-shrink-0 tw-px-4 tw-py-2 tw-font-bold tw-text-white tw-rounded-md tw-shadow-sm hover:tw-shadow tw-transition-all tw-flex tw-items-center tw-gap-2 tw-text-sm"
              style="background-color: #a6ce39"
            >
              <svg class="tw-w-4 tw-h-4 tw-fill-current" viewBox="0 0 256 256">
                <path
                  d="M256 128c0 70.7-57.3 128-128 128S0 198.7 0 128 57.3 0 128 0s128 57.3 128 128z"
                  fill="#ffffff"
                />
                <path
                  d="M86.3 186.2H70.9V79.1h15.4v107.1zM108.9 79.1h41.6c39.6 0 57 28.3 57 53.6 0 27.5-21.5 53.5-56.8 53.5h-41.8V79.1zm15.4 92.4h24.5c34.5 0 41.7-25.5 41.7-38.9 0-17.5-11.2-38.8-42.6-38.8h-23.6v77.7z"
                  fill="#a6ce39"
                />
              </svg>
              <span>Sign in with ORCID</span>
            </button>
          </div>
        </div>

        <div *ngIf="leaderboardOptions$ | async as leaderboardOptions">
          <resource-leaderboard
            [resource]="resource"
            [options]="leaderboardOptions"
          ></resource-leaderboard>
        </div>

        <div class="tw-my-2 sm:tw-my-4" *ngIf="terms.length > 0">
          <cdk-accordion>
            <cdk-accordion-item #termAccordion="cdkAccordionItem">
              <div class="tw-flex tw-flex-row tw-justify-between tw-p-1">
                <h4 class="tw-text-xl tw-font-dm-sans tw-font-semibold">
                  What Contributions can be done on
                  {{ resource.resource_name }} ?
                </h4>
                <button
                  class="tw-text-blue-400 hover:tw-text-blue-500 tw-bg-transparent tw-text-sm tw-border-0 focus:tw-outline-none hover:tw-underline"
                  (click)="termAccordion.toggle()"
                >
                  {{ termAccordion.expanded ? "show less" : "show more" }}
                </button>
              </div>
              <div class="tw-flex tw-gap-2 tw-flex-row tw-flex-no-wrap">
                <div *ngFor="let term of terms.slice(0, 4)" class="tw-w-1/4">
                  <term-card [term]="term"></term-card>
                </div>
              </div>
              <div
                #collapsedTerms
                class="tw-grid tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-ease-in-out"
                [style.height.px]="
                  termAccordion.expanded ? collapsedTerms.scrollHeight : 0
                "
              >
                <div class="tw-flex tw-flex-row tw-flex-wrap">
                  <div
                    *ngFor="let term of terms.slice(4)"
                    class="tw-w-1/4 tw-p-1"
                  >
                    <term-card [term]="term"></term-card>
                  </div>
                </div>
              </div>
            </cdk-accordion-item>
          </cdk-accordion>
        </div>

        <div class="tw-my-2 sm:tw-my-4" *ngIf="firstBadges$ | async as badges">
          <cdk-accordion>
            <cdk-accordion-item #badgeAccordion="cdkAccordionItem">
              <div
                class="tw-flex tw-w-full tw-flex-row tw-justify-between tw-pr-2"
                *ngIf="badges.data.length > 0"
              >
                <h4 class="tw-text-xl tw-font-dm-sans tw-font-semibold tw-mb-2">
                  Badges
                </h4>

                <button
                  *ngIf="badges.meta.pagination.total > badges.data.length"
                  class="tw-text-blue-400 hover:tw-text-blue-500 tw-bg-transparent tw-text-sm tw-border-0 focus:tw-outline-none hover:tw-underline"
                  (click)="badgeAccordion.toggle()"
                >
                  {{ badgeAccordion.expanded ? "show less" : "show more" }}
                </button>
              </div>

              <div class="tw-flex tw-flex-row tw-gap-3 tw-flex-wrap">
                <div
                  *ngFor="let badge of badges.data"
                  class="tw-basis-[23%] tw-flex-grow tw-max-w-[25%]"
                >
                  <badge-def-card
                    [badge]="badge"
                    [terms]="terms"
                  ></badge-def-card>
                </div>
              </div>
              <ng-container *ngIf="lastBadges$ | async as lastBadges">
                <div
                  class="tw-flex tw-flex-row tw-flex-wrap tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-ease-in-out"
                  #collapsedBadges
                  [style.height.px]="
                    badgeAccordion.expanded ? collapsedBadges.scrollHeight : 0
                  "
                >
                  <div
                    *ngFor="let badge of lastBadges.data"
                    class="tw-p-2 tw-w-1/4"
                  >
                    <badge-def-card
                      [badge]="badge"
                      [terms]="terms"
                    ></badge-def-card>
                  </div>
                </div>
              </ng-container>
            </cdk-accordion-item>
          </cdk-accordion>
        </div>

        <div class="tw-my-2 sm:tw-my-4" *ngIf="firstMedals$ | async as medals">
          <cdk-accordion>
            <cdk-accordion-item #medalAccordion="cdkAccordionItem">
              <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between tw-pr-2"
                *ngIf="medals.data.length > 0"
              >
                <h4 class="tw-text-xl tw-font-dm-sans tw-font-semibold">
                  Medals
                </h4>

                <button
                  *ngIf="medals.meta.pagination.total > medals.data.length"
                  class="tw-text-blue-400 hover:tw-text-blue-500 tw-bg-transparent tw-text-sm tw-border-0 focus:tw-outline-none hover:tw-underline"
                  (click)="medalAccordion.toggle()"
                >
                  {{ medalAccordion.expanded ? "show less" : "show more" }}
                </button>
              </div>

              <!-- content -->
              <div class="tw-flex tstatsw-flex-row tw-flex-wrap">
                <div
                  *ngFor="let medal of medals.data"
                  class="tw-p-2 tw-basis-1/4"
                >
                  <medal-def-card
                    class="tw-h-full"
                    [medal]="medal"
                    [terms]="terms"
                  ></medal-def-card>
                </div>
              </div>

              <div
                #collapsedMedals
                class="tw-grid tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-ease-in-out"
                [style.height.px]="
                  medalAccordion.expanded ? collapsedMedals.scrollHeight : 0
                "
              >
                <div
                  class="tw-flex tw-flex-row tw-flex-wrap"
                  *ngIf="lastMedals$ | async as lastMedals"
                >
                  <div
                    *ngFor="let medal of lastMedals.data"
                    class="tw-p-2 tw-w-1/4"
                  >
                    <medal-def-card
                      class="tw-h-full"
                      [medal]="medal"
                      [terms]="terms"
                    ></medal-def-card>
                  </div>
                </div>
              </div>
            </cdk-accordion-item>
          </cdk-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- expansion -->
